import { Onix } from './Onix';

export class StatusLog {
  date: Date;
  publishingDetail: Onix;
  productAvailability: Onix;
  priceAmount: number;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/StatusLog.ts